import { useEffect } from 'react';
import { useProductRegistrationContext } from '@/product-registration/context';

const useLoadSelectPage = () => {
  const [
    ,
    { setActiveStep, setInputTerm, setSelectedProduct, unsetSearch },
  ] = useProductRegistrationContext();
  useEffect(() => {
    setActiveStep(1);
    setInputTerm('');
    unsetSearch();
    setSelectedProduct(null);
  }, []);
};

export default useLoadSelectPage;
